import { parseISO, format, formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export const formatarDataCompleta = (dataString) => {
    const date = parseISO(dataString);
    return format(date, "dd/MM/yyyy - HH:mm:ss");
};

export const tempoDecorrido = (dataString) => {
    const date = parseISO(dataString);
    return formatDistanceToNow(date, { addSuffix: true, locale: ptBR });
};

export const getColorBasedOnTime = (tempoDecorrido) => {
    const match = tempoDecorrido.match(/(\d+)\s+(\w+)/);
    if (match) {
        const quantidade = parseInt(match[1], 10);
        const unidade = match[2];

        if (unidade === 'hora' || unidade === 'horas') {
            return quantidade >= 1 ? 'red' : 'green';
        } else if (unidade === 'minuto' || unidade === 'minutos') {
            return quantidade >= 60 ? 'red' : quantidade >= 30 ? 'yellow' : 'green';
        }
    }
    return 'red';
};

export const getTextColorForBg = (color) => {
    return color === 'yellow' ? 'black' : 'white';
};

export const formatarData = (dateString) => {
  if (!dateString) return '';
  const data = new Date(dateString);
  return data.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }); // Saída: 24/08/2025
};

export const formatarHora = (dateString) => {
  if (!dateString) return '';
  const data = new Date(dateString);
  return data.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  }); // Saída: 10:44
};